<template>
  <div>
    <b-container fluid>
      <b-row>
        <b-col v-if="currentRoute != 'Home'">
          <TopBar/>
        </b-col>
      </b-row>
    </b-container>
    <router-view class="view" />
  </div>
    
    <!-- <GLMap/>
    <MiniappTray/>
    <Sidebar/>
    <Burger/>
    <Filter1/>
    <TopBar/>
    <Result/> -->
    
</template>

<style>
body { 
  margin: 0; 
}
/*
#app {
  margin: 0;
  height: 10vh;
}
*/

.view {
  height: 87vh;
}


</style>

<script>
// import GLMap from './components/map/GLMap'
// import MiniappTray from './components/miniapp/MiniappTray'
// import Sidebar from './components/sidebar/Sidebar'
// import Burger from './components/other/Burger'
// import Filter1 from './components/other/Filter1'
 import TopBar from './components/other/TopBar'
// import Result from './components/other/result/Result'

export default {
  name: 'App',
  components: {
    // GLMap,
    // MiniappTray,
    // Sidebar,
    //Burger,
    // Filter1,
    TopBar,
    // Result
  },
  data() {
    return {

    }
  },
  computed: {
    currentRoute() {
      return this.$route.name
    }
  },
  methods: {

  }
}
</script>
